import * as Yup from 'yup';
import { Address } from 'utils/schemas';
import { DB_PREFIX } from './constants';

export default Yup.object().shape({
  [DB_PREFIX]: Address,
});
